import { apiHelper } from "./api_helper";

export const PHU_HUYNH_API_END_POINT = "phu-huynh";
export const PHU_HUYNH_UPATE_STATS_API_END_POINT = "phu-huynh/status";

export const hoSoSurveyApi = {
    SelectAll: (ts_hoso_survey_status_id) => apiHelper.get(`ho-so/status/${ts_hoso_survey_status_id ? ts_hoso_survey_status_id : 0}`),
    SelectByPhuHuynh: (ts_phuhuynh_id) => apiHelper.get(`phu-huynh/${ts_phuhuynh_id}/ho-so`),
    SelectStatusSummary: () => apiHelper.get('ho-so/status-summary'),
    SelectStatus: () => apiHelper.get('ho-so/status'),
    UpdateStatus: (data) => apiHelper.put('ho-so/status', data),
    ValidateUniqueKey: (data) => apiHelper.post('ho-so/valid', data),
    Detail: (id) => apiHelper.get(`ho-so/${id}`),
    Insert: (data) => apiHelper.post('ho-so',data),
    Update: (data) => apiHelper.put('ho-so',data),
    Delete: (id) => apiHelper.delete(`ho-so/${id}`),
}